/**
 * 需要前端做映射显示的相关逻辑都写下本文推荐
 */

/**
 * 国家code 显示映射 源数据
 */
const FE_COUNTRY_CODE_MAP = {
  GB: 'UK'
  // US: 'US1',
  // TH: 'TH1',
  // CA: 'CA1',
  // MY: 'MY1'
}

/**
 * 获取前端显示国家码 的管道
 * @param {String} countryCode
 * @returns
 */
export const pipeCountryCode = (countryCode) => {
  const feShowCode = FE_COUNTRY_CODE_MAP[countryCode]
  return feShowCode || countryCode
}
